<script setup>
    const file = defineModel()
    defineProps({
        required: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: '.csv'
        }
    })
</script>

<template>
    <b-upload v-model="file"
              :accept="accept"
              :required="required"
              drag-drop>
        <section class="section">
            <div class="content has-text-centered">
                <p>
                    <b-icon class="is-size-1"
                            icon="upload"
                            size="is-large">
                    </b-icon>
                </p>
                <p>{{ $t('file_upload.drop_or_click')}}</p>
                <p v-if="file">{{ $t('file_upload.selected_file') }}: {{ file.name }}</p>
            </div>
        </section>
    </b-upload>
</template>
